import { Flag } from '@fullstory/proto/fs/shared/flags';
import { FstaFlags } from './goimports/fs_featureflags_fsta';

// The source of truth for flags is flags.proto. New flags should be added there and then `make generate` is used to generate
// the go and typescript bindings.

export class UserFlags {
  constructor(private _flags: { [flag: number]: number } = {}) {
  }

  // Returns the underlying map.
  jsonFlags(): { [flag: number]: number } {
    return this._flags;
  }

  // Determines whether given number flag exists (regardless of its value).
  has(flag: number): boolean {
    return flag in this._flags;
  }

  // Returns the given flag. Returns 0 if absent.
  get(flag: number): number {
    return this._flags[flag] || 0;
  }

  // Determines whether the given flag both exists and has a non-zero value.
  hasBit(flag: number): boolean {
    return this.has(flag) && this.get(flag) != 0;
  }

  hasBits(...flags: number[]): boolean {
    return flags.every(flag => this.hasBit(flag));
  }

  // Determines whether the given flag both exists and has at least the given value.
  hasAtLeast(flag: number, exp: number): boolean {
    return this.has(flag) && this.get(flag) >= exp;
  }

  // Sets the given number flag.
  set(flag: number, value: number) {
    this._flags[flag] = value;
  }

  // Clears the given flag.
  clear(flag: number) {
    delete this._flags[flag];
  }
}

export class Flags extends UserFlags {
  static PermissionFlags: number[] = [];
  // note - these are proto flags, and not Launch Darkly Feature Flags
  static FeatureFlags: number[] = [];
  static SearchieFlags: number[] = [];

  constructor(flags: { [flag: number]: number } = {}, private _featureFlags: FstaFlags = <FstaFlags>{}) {
    super(flags);
  }

  // Launch Darkly feature flags
  featureFlags(): FstaFlags {
    return this._featureFlags;
  }
}

Object.keys(Flag).forEach((k) => {
  let n = Number(k)
  if (!isNaN(n)) {
    let fl: Flag = n;
    let key = Flag[fl];
    // Separate flags into functional maps
    if (key?.indexOf("Perm") == 0) {
      Flags.PermissionFlags.push(fl);
    } else if (key?.indexOf("Feat") == 0) {
      Flags.FeatureFlags.push(fl);
    } else if (key?.indexOf("Searchie") == 0) {
      Flags.SearchieFlags.push(fl);
    }
  }
});
